import { Component, OnInit } from '@angular/core';
import { environment } from '../../environments/environment';

declare const SwaggerUIBundle: any;

@Component({
  selector: 'app-api-doc',
  templateUrl: './api-doc.component.html',
  styleUrls: ['./api-doc.component.scss']
})
export class ApiDocComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    const ui = SwaggerUIBundle({
      dom_id: '#swagger-ui',
      layout: 'BaseLayout',
      presets: [
        SwaggerUIBundle.presets.apis,
        SwaggerUIBundle.SwaggerUIStandalonePreset
      ],
      url: environment.client + '/api/api-doc',
      docExpansion: 'full',
      operationsSorter: 'alpha'
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/api-doc/api-doc.component.ts